import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IConditionCodeDto,
  IConditionCodePagedResultDto,
  IConditionCodeCreateUpdateRequest
} from '../interfaces/Kroll/icondition-code-dto';

@Injectable({
  providedIn: 'root'
})
export class ConditionCodeService {
  private apiUrl = '';

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl + 'api/Kroll/';
  }

  getConditionCodes(
    page: number = 1,
    pageSize: number = 10,
    code?: string,
    description?: string,
    includeDeleted: boolean = true
  ): Observable<IConditionCodePagedResultDto> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('includeDeleted', includeDeleted.toString());
    if (code != null && code.trim() !== '')
      params = params.set('code', code.trim());
    if (description != null && description.trim() !== '')
      params = params.set('description', description.trim());
    return this.http.get<IConditionCodePagedResultDto>(this.apiUrl + 'ConditionCodes', { params });
  }

  getConditionCode(id: number): Observable<IConditionCodeDto> {
    return this.http.get<IConditionCodeDto>(this.apiUrl + 'ConditionCodes/' + id);
  }

  createConditionCode(request: IConditionCodeCreateUpdateRequest): Observable<IConditionCodeDto> {
    return this.http.post<IConditionCodeDto>(this.apiUrl + 'ConditionCodes', request);
  }

  updateConditionCode(id: number, request: IConditionCodeCreateUpdateRequest): Observable<IConditionCodeDto> {
    return this.http.post<IConditionCodeDto>(this.apiUrl + 'ConditionCodes/Update/' + id, request);
  }
}
